import * as React from "react";
import { BarChart, PieChart, useDrawingArea } from '@mui/x-charts';
import { Box, styled, Tab, Tabs } from "@mui/material";

const PieChartDoughnut = ({ chart_data, isFullWidth }) => {

    const { chartType, type, chart_type, xAxis, yAxis, daily, weekly, data } = chart_data;
    const chartViewType = chartType || type || chart_type;
    const isMultipleTabs = daily && weekly;

    const getChartData = () => {
        return data?.map(d => ({
            value: d?.percentage ?? d?.wins,
            label: d?.status ?? d?.category,
        })) ?? [];
    };

    const pieChartData = getChartData();

    const size = {
        width: 300,
        height: 380,
    };

    const StyledText = styled('text')(({ theme }) => ({
        fill: theme.palette.text.primary,
        textAnchor: 'middle',
        dominantBaseline: 'central',
        fontSize: 20,
    }));

    function PieCenterLabel({ children }) {
        const { width, height, left, top } = useDrawingArea();
        return (
            <StyledText x={left + width / 2} y={top + height / 2}>
                {children}
            </StyledText>
        );
    }

    return (
        <div style={isFullWidth ? styles.cardFull : styles.cardHalf}>
            <h3>{chart_data?.title || chart_data?.chart_name}</h3>
            <p>{chart_data?.description}</p>
            {data && data.length > 0 && (
                <PieChart series={[
                    {
                        data: pieChartData,
                        innerRadius: 50,
                        arcLabel:'value'
                    }]} {...size}>
                    {/* <PieCenterLabel>Center label</PieCenterLabel> */}
                </PieChart>)}
        </div>
    );

}

const styles = {
    cardHalf: {
        flex: 0.48,
        padding: 20,
        border: '1px solid #ccc',
        borderRadius: '12px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'left',
    },
    cardFull: {
        flex: 1,
        padding: 20,
        border: '1px solid #ccc',
        borderRadius: '12px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'left',
    },
};

export default PieChartDoughnut;